var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.64706 0H4.94118L6.58824 4.11765L4.52941 5.35294C5.41138 7.14126 6.85874 8.58862 8.64706 9.47059L9.88235 7.41176L14 9.05882V12.3529C14 12.7898 13.8265 13.2087 13.5176 13.5176C13.2087 13.8265 12.7898 14 12.3529 14C9.14057 13.8048 6.11071 12.4406 3.83504 10.165C1.55936 7.88929 0.195217 4.85943 0 1.64706C0 1.21023 0.173529 0.791296 0.482412 0.482412C0.791296 0.173529 1.21023 0 1.64706 0Z",
    fill: "#1F396C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.52abcb64757fcd3d830abc103cf47de3.svg";
export { ForwardRef as ReactComponent };